import { useContext } from "react";
import { getAppConfig } from "@config/appConfig";
import { CLASS_IMAX, CLASS_PREMIUM_PLUS } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import { getAllExperiences } from "@utils/ticketUtils";

export const useExperiences = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const config = getAppConfig();
    const types = getAllExperiences();

    const availableTicketClassIds = (whiteLabel?.ticket_class_subscriber_group || [])
        .map(x => x.ticket_class_id);

    const availableExperiences = types
        .filter(type => type.id !== CLASS_PREMIUM_PLUS && type.id !== CLASS_IMAX)
        .filter(type => availableTicketClassIds.includes(type.id))
        .map(exp => ({ ...exp, config }));

    return availableExperiences;
};
